export default __webpack_public_path__ + "static/media/Totem of the Blood God.2b46a846.jpg";